import axiosInstance from 'api/axiosInstance';
import { CANtrackComment } from 'containers/pages/comments/types/comment';

export const createComment = async (
	comment: CANtrackComment,
): Promise<number> => {
	const data = {
		payload: {
			id: null,
			TaskTitle: comment.title,
			Description: comment.description,
			CustomerId: comment.customerID,
			CaseId: comment.caseID,
			ActivityID: comment.gpda.activity.id,
			EntryDate: comment.date.toISOString(),
			TimeRegular: comment.timeRegular.toString(),
			TimeOver: comment.timeOver.toString(),
			DeliverableId: comment.gpda.deliverable.id,
			Billable: comment.billable ? 'Y' : 'N',
			UserId: comment.userId || null,
			UserContactId: comment.contactId || null,
		},
	};
	try {
		const response = await axiosInstance.post(
			`/api/cantrackv3/CreateComment`,
			data,
		);
		const payloadId = response.data?.Payload?.Id;
		const parsedId = parseInt(payloadId, 10);

		if (response.status !== 200 || isNaN(parsedId)) {
			throw new Error(
				`Error creating comment: Status ${response.status}`,
			);
		}

		return parsedId;
	} catch (error) {
		console.error('createComment error:', error);
		throw error;
	}
};
